import styled from 'styled-components';

export const PickerContainer = styled.div<{ $isMobile: boolean; $order: number }>`
  display: flex;
  flex-direction: column;
  align-items: center;

  margin-top: 16px;

  ${({ $isMobile, $order }) =>
    $isMobile &&
    `
      flex-wrap: nowrap;
      white-space: nowrap;
      align-items: baseline;
      order: ${$order};
  `}
`;
